export const API_KEY = '897ba858-ad19-4c15-bed6-68cb35c68ba1';
